import {useState} from "react";
import useAxios from "axios-hooks";
import DeleteConfirmationDialog from "../../../Util/DeleteConfirmationDialog";

const DeleteAudioModal = ({
  showModal,
  toggleShowModal,
  onDelete,
  audioId,
  audioTitle,
  setErrorMsg,
  setShowError,
  setShowSuccess,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [{ loading }, executeDelete] = useAxios(
    {
      method: "delete",
      url: `resources/audio/${audioId}/`,
    },
    { manual: true }
  );

  const onConfirmDelete = async () => {
    try {
      const response = await executeDelete();
      if (response?.status >= 200 && response?.status < 300) {
        setErrorMessage("");
        onDelete?.();
        toggleShowModal();
        setShowSuccess?.(true);
        setTimeout(() => {
          setShowSuccess?.(false);
        }, 2000);
        return true;
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message || error?.response?.data || error?.message;
      const resolvedMessage = apiMessage || "Unable to delete this audio. Please try again.";
      setErrorMessage(resolvedMessage);
      setShowError?.(true);
      setErrorMsg?.(resolvedMessage);
    }

    return false;
  };

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessage("");
        toggleShowModal();
      }}
      onConfirm={onConfirmDelete}
      resourceName={audioTitle}
      resourceType="audio"
      confirmationValue={audioTitle || "delete"}
      isDeleting={loading}
      errorMessage={errorMessage}
    />
  );
};

export default DeleteAudioModal;